



const allForms = () => {

    $.validator.addMethod('regexp', function (value, element, param) {
        return this.optional(element) || value.match(param);
    });
    $.validator.addMethod('custom_required', function (value, element, param) {
        // Check if dependency is met
        if (!this.depend(param, element)) {
            return "dependency-mismatch";
        }
        if (element.nodeName.toLowerCase() === "select") {

            // Could be an array for select-multiple or a string, both are fine this way
            let val = $(element).val();
            return val && val.length > 0;
        }
        if (this.checkable(element)) {
            return this.getLength(value, element) > 0;
        }
        return value !== undefined && value !== null && value.length > 0;
    });

}

function validateHighlight(element, errorClass, validClass) {
    // if (element.type === "checkbox") {
    //     $(element).parents('.checkbox__item').removeClass(validClass).addClass(errorClass);
    //     return;
    // }
    $(element).parents('.form__col').removeClass(validClass).addClass('has-error');
}

function validateUnHighlight(element, errorClass, validClass) {
    // if (element.type === "checkbox") {
    //     $(element).parents('.checkbox__item').removeClass(errorClass).addClass(validClass);
    //     return;
    // }
    $(element).parents('.form__col').removeClass('has-error').addClass(validClass);
}

function validateErrorPlacement(error, element) {
    const parentElement = element.prop('parentElement');
    error.appendTo($(parentElement));
}

function validateSubmitHandler(submit__form) {
    submit__form.submit();
}

const validateDefaults = {
    errorPlacement: validateErrorPlacement,
    highlight: validateHighlight,
    unhighlight: validateUnHighlight,
    submitHandler: validateSubmitHandler
};


allForms()

export default validateDefaults
